import {
  IconButton,
  MenuItem,
  TextField
} from "@mui/material";
import Typography from '@mui/material/Typography';
import { capitalize } from "lodash";
import { DropzoneArea } from "material-ui-dropzone";
import { useState } from "react";
import { useTranslate } from "react-admin";
import { utils, writeFile } from 'xlsx';
import globalUseStyles from "../../../styles/globalCustomStyles";

import { faFileArrowDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SyncSourceMain = (props) => {
  const globalClasses = globalUseStyles();
  const t = useTranslate();

  const PIVOT_FILE_HEADERS = ['username', 'email', 'role', 'enabled', 'perimeterSitesCodes', 'perimeterDevicesCodes', 'timeConstraintPerimeterDevices', 'excludedPerimeterSites', 'excludedPerimeterDevices', 'globalStartDate', 'globalEndDate', 'globalDevicesCodes'];
  const PM_FILE_HEADERS = ['username', 'email', 'role', 'enabled', 'perimeterSitesCodes', 'perimeterDevicesCodes', 'timeConstraintPerimeterDevices', 'excludedPerimeterSites', 'excludedPerimeterDevices', 'globalStartDate', 'globalEndDate', 'globalDevicesCodes'];
  const LOC_FILE_HEADERS = ['username', 'email', 'role', 'enabled', 'perimeterSitesCodes', 'globalStartDate', 'globalEndDate', 'globalDevicesCodes', 'perimeterDevicesCodes', 'timeConstraintPerimeterDevices', 'excludedPerimeterSites', 'excludedPerimeterDevices'];

  const onUploadFile = (e) => {
    props.onUploadFile(e);
  }

  const getFileName = (fileName) => {
    if (fileName !== 'example') {
      const actualDate = new Date()
      let formattedDate = actualDate.toISOString().split('T')[0]
      return `${fileName}_${formattedDate}.xlsx`;
    }
    return 'exemple.xlsx';
  }


  const downloadExampleFile = (headers, fileName) => {
    let ws = utils.aoa_to_sheet([headers]);
    let wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'example');
    writeFile(wb, getFileName(fileName));
  }

  const SourceExcelFields = () => {
    return (
      <div className={globalClasses.syncExcel}>
        <div className={globalClasses.dropzoneContainer}>
          <DropzoneArea
            onChange={onUploadFile}
            dropzoneText={t("users.configuration.dropzone_text")}
            showPreviews={true}
            showPreviewsInDropzone={false}
            useChipsForPreview
            previewText=""
            showAlerts={false}
            clearOnUnmount={false}
            filesLimit={1}
            acceptedFiles={[".csv", ".xlsx"]}
          />
        </div>

        <div className={globalClasses.syncLineContainer}>
          <IconButton onClick={() => downloadExampleFile(PIVOT_FILE_HEADERS, "example")}>
            <FontAwesomeIcon icon={faFileArrowDown} color="#71B9A1" style={{ paddingRight: "10px", height: "40px" }} />
          </IconButton>
          <Typography>{t("users.configuration.download_exemple_file")}</Typography>
        </div>
        <div className={globalClasses.syncLineContainer}>

          <IconButton onClick={() => downloadExampleFile(PM_FILE_HEADERS, "import_pm")}>
            <FontAwesomeIcon icon={faFileArrowDown} color="#71B9A1" style={{ paddingRight: "10px", height: "40px" }} />
          </IconButton>
          <Typography>{t("users.configuration.download_pm_file")}</Typography>
        </div>
        <div className={globalClasses.syncLineContainer}>
          <IconButton onClick={() => downloadExampleFile(LOC_FILE_HEADERS, "import_loc")}>
            <FontAwesomeIcon icon={faFileArrowDown} color="#71B9A1" style={{ paddingRight: "10px", height: "40px" }} />
          </IconButton>
          <Typography>{t("users.configuration.download_tenant_file")}</Typography>
        </div>
      </div >
    );
  };

  const possibleSources = [
    { id: "excel", component: <SourceExcelFields /> }
  ]

  const [source, setSource] = useState(possibleSources[0].id);


  return (
    <div className={globalClasses.UserGeneralInformation}>
      <TextField
        id="source"
        required
        label={t("users.configuration.source")}
        variant="outlined"
        select
        onChange={(e) => setSource(e.target.value)}
        value={source}
        className={globalClasses.UserField}>
        {possibleSources.map((source) => (
          <MenuItem key={source.id} value={source.id}>
            {capitalize(source.id)}
          </MenuItem>
        ))}
      </TextField>
      {possibleSources.filter((component) => component.id === source)[0].component}
    </div>
  );
};

export default SyncSourceMain;
